var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      staticClass: "terminal-modal",
      attrs: {
        title: "Payment in progress",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "hide-footer": "",
        centered: "",
        size: "sm",
      },
      on: { hidden: _vm.cancelCharge },
      model: {
        value: _vm.terminalIsRequesting,
        callback: function ($$v) {
          _vm.terminalIsRequesting = $$v
        },
        expression: "terminalIsRequesting",
      },
    },
    [_vm._v("\n    " + _vm._s(_vm.terminalMessage) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }